function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["uid", "name"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { HooksContext } from "./hooksProvider";
import { useContext, useEffect } from 'react';
function useUmamiInject(props) {
  var umamiSrc = props.umamiSrc,
    umamiId = props.umamiId;
  useEffect(function () {
    var createUmamiSript = function createUmamiSript(src, id) {
      var umamiScript = document.createElement('script');
      umamiScript.type = 'text/javascript';
      umamiScript.src = src;
      umamiScript.dataset.websiteId = id;
      umamiScript.async = true;
      umamiScript.dataset.umamiScript = 'true';
      document.body.appendChild(umamiScript);
    };
    if (umamiId && umamiSrc) {
      var findOldUmamiScript = document.querySelector('script[data-umami-script=true]');
      if (findOldUmamiScript) {
        document.body.removeChild(findOldUmamiScript);
        createUmamiSript(umamiSrc, umamiId);
      } else {
        createUmamiSript(umamiSrc, umamiId);
      }
    }
  }, [umamiId, umamiSrc]);
}
function useWebTrack(props) {
  var _useContext = useContext(HooksContext),
    umamiHooksProps = _useContext.umamiHooksProps;
  var onError = (props === null || props === void 0 ? void 0 : props.onError) || (umamiHooksProps === null || umamiHooksProps === void 0 ? void 0 : umamiHooksProps.onError);
  var onSend = (props === null || props === void 0 ? void 0 : props.onSend) || (umamiHooksProps === null || umamiHooksProps === void 0 ? void 0 : umamiHooksProps.onSend);
  var isPc = !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  return {
    sendEvent: function sendEvent(data) {
      var uid = data.uid,
        name = data.name,
        otherData = _objectWithoutProperties(data, _excluded);
      var umami = window.umami;
      if (umami) {
        try {
          var umamiData = function umamiData(props) {
            return _objectSpread(_objectSpread({}, props), {}, {
              name: name,
              data: _objectSpread(_objectSpread({}, otherData), {}, {
                uid: String(uid),
                platform: isPc ? 'pc' : 'mobile',
                time: String(Date.now())
              })
            });
          };
          umami.track(function (props) {
            var res = umamiData(props);
            onSend === null || onSend === void 0 || onSend(res);
            return res;
          });
        } catch (e) {
          onError === null || onError === void 0 || onError(e);
        }
      } else {
        console.error('缺少umami实例，无法执行埋点');
      }
    }
  };
}
export { useUmamiInject, useWebTrack };